import { __awaiter, __generator } from 'tslib';
import { signUpCoreX } from '../../../sdk/sign-up-sdk.js';
import { SET_SIGN_UP_DATA, SET_SIGN_UP_FORM, RESET_FORM_MODEL, RESET } from './sign-up.constants.js';
import { getVerificationMethod } from '../../../utils/verification-type.js';

var _a;
var getInitialState = function () { return ({
    authModel: {
        username: null,
        email: '',
        password: '',
        givenName: null,
        familyName: null,
        gender: null,
        birthDate: null,
        taxId: null,
        addrStreetAddress: null,
        addrLocality: null,
        addrCountryCode: '',
        addrPostalCode: null,
        currencyCode: '',
        mobileNumber: null,
        mobilePrefix: null,
        termsAndConditionsVersion: '',
        privacyPolicyVersion: '',
        optIn: false,
        userID: '',
        verificationTypeID: 0,
    },
    formModel: {},
}); };
var getters = {
    authModel: function (state) {
        return state.authModel;
    },
    formModel: function (state) {
        return state.formModel;
    },
    verificationType: function (state) {
        return state.authModel.verificationTypeID;
    },
};
var actions = {
    updateSignupData: function (_a, data) {
        var commit = _a.commit;
        commit(SET_SIGN_UP_DATA, data);
    },
    updateFormData: function (_a, data) {
        var commit = _a.commit;
        commit(SET_SIGN_UP_FORM, data);
    },
    register: function (_a) {
        var state = _a.state, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = state.authModel;
                        return [4 /*yield*/, signUpCoreX(params)];
                    case 1:
                        response = _b.sent();
                        commit(SET_SIGN_UP_DATA, { userID: response.userID });
                        return [2 /*return*/, response];
                }
            });
        });
    },
    resetFormModel: function (_a) {
        var commit = _a.commit;
        commit(RESET_FORM_MODEL);
    },
    reset: function (_a) {
        var commit = _a.commit;
        commit(RESET);
    },
    fetchVerificationType: function (_a, preferred) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var typeId;
            return __generator(this, function (_b) {
                typeId = getVerificationMethod(state.authModel.addrCountryCode, preferred);
                commit(SET_SIGN_UP_DATA, {
                    verificationTypeID: typeId,
                });
                return [2 /*return*/, typeId];
            });
        });
    },
};
var signUp = {
    namespaced: true,
    state: getInitialState(),
    actions: actions,
    getters: getters,
    mutations: (_a = {},
        _a[SET_SIGN_UP_DATA] = function (state, payload) {
            Object.assign(state.authModel, payload);
        },
        _a[SET_SIGN_UP_FORM] = function (state, payload) {
            Object.assign(state.formModel, payload);
        },
        _a[RESET_FORM_MODEL] = function (state) {
            state.formModel = {};
        },
        _a[RESET] = function (state) {
            Object.assign(state, getInitialState());
        },
        _a),
};

export { actions, getters, signUp };
